import { render, staticRenderFns } from "./stores.vue?vue&type=template&id=6d9178e7&"
import script from "./stores.vue?vue&type=script&lang=js&"
export * from "./stores.vue?vue&type=script&lang=js&"
import style0 from "./stores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9178e7')) {
      api.createRecord('6d9178e7', component.options)
    } else {
      api.reload('6d9178e7', component.options)
    }
    module.hot.accept("./stores.vue?vue&type=template&id=6d9178e7&", function () {
      api.rerender('6d9178e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/stores.vue"
export default component.exports